module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }, [_c('p', {
    staticClass: "subtitle1y"
  }, [_vm._v("DIE WEHRMACHT IM KAMPF")]), _vm._v(" "), _c('h1', {
    staticClass: "titley"
  }, [_vm._v("THE BATTLE OF KORSUN-CHERKASSY")]), _vm._v(" "), _c('p', {
    staticClass: "subtitley"
  }, [_vm._v("The Encirclement and Breakout of Army Group South, 1944")]), _vm._v(" "), _c('p', {
    staticClass: "authory"
  }, [_vm._v("NIKOLAUS VON VORMANN")]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Translated by")])]), _vm._v(" "), _c('p', {
    staticClass: "author1y"
  }, [_vm._v("GEOFFREY BROOKS")]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Series editor:")])]), _vm._v(" "), _c('p', {
    staticClass: "author1y"
  }, [_vm._v("MATTHIAS STROHN")]), _vm._v(" "), _c('p', {
    staticClass: "pub"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pub.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c0d47ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_Title.vue
// module id = 63
// module chunks = 0